import { PluralForm } from '@nimbus-library/features/localization/models/enums/pluralform.enum';

export class LocalizableError {
  public constructor(
    public readonly translateKey: string,
    public readonly pluralForm: PluralForm,
    public readonly value?: string,
  ) {}
}

export class LocalizableDependentError {
  public constructor(
    public readonly translateKey: string,
    public readonly dependencies: ErrorDependencies[],
  ) {}
}

export interface ErrorDependencies {
  item: string;
  dependentItems: string[];
}
